export const CONTEST_CASHBACK_MONTHS = {
    start: '2026-11',
    end: '2027-06',
} as const;

/** lead-city / contest id=10 */
export const LEAD_CITY_CONTEST_ID = 10;

const MONTH_LABELS: Record<string, string> = {
    '01': 'Январь',
    '02': 'Февраль',
    '03': 'Март',
    '04': 'Апрель',
    '05': 'Май',
    '06': 'Июнь',
    '07': 'Июль',
    '08': 'Август',
    '09': 'Сентябрь',
    '10': 'Октябрь',
    '11': 'Ноябрь',
    '12': 'Декабрь',
};

function parseMonth(value: string): { year: number; month: number } {
    const [year, month] = value.split('-').map(Number);
    return { year, month };
}

function formatMonth(year: number, month: number): string {
    return `${year}-${String(month).padStart(2, '0')}`;
}

export function getContestMonthOptions(): { text: string; value: string }[] {
    const start = parseMonth(CONTEST_CASHBACK_MONTHS.start);
    const end = parseMonth(CONTEST_CASHBACK_MONTHS.end);
    const options: { text: string; value: string }[] = [];

    let year = start.year;
    let month = start.month;

    while (year < end.year || (year === end.year && month <= end.month)) {
        const value = formatMonth(year, month);
        const monthKey = String(month).padStart(2, '0');
        options.push({
            text: `${MONTH_LABELS[monthKey]} ${year}`,
            value,
        });

        month += 1;
        if (month > 12) {
            month = 1;
            year += 1;
        }
    }

    return options;
}

export function getDefaultContestMonth(): string {
    const now = new Date();
    const current = formatMonth(now.getFullYear(), now.getMonth() + 1);

    if (current < CONTEST_CASHBACK_MONTHS.start) {
        return CONTEST_CASHBACK_MONTHS.start;
    }

    if (current > CONTEST_CASHBACK_MONTHS.end) {
        return CONTEST_CASHBACK_MONTHS.end;
    }

    return current;
}

export function clampContestMonth(month: string): string {
    if (month < CONTEST_CASHBACK_MONTHS.start) {
        return CONTEST_CASHBACK_MONTHS.start;
    }

    if (month > CONTEST_CASHBACK_MONTHS.end) {
        return CONTEST_CASHBACK_MONTHS.end;
    }

    return month;
}

export function getContestMonthDateBounds(month: string): { start: Date; end: Date } {
    const { year, month: monthNum } = parseMonth(month);
    const start = new Date(year, monthNum - 1, 1);
    const end = new Date(year, monthNum, 0);

    return { start, end };
}

function formatYmdToDisplay(date: string): string {
    const [year, month, day] = date.split('-');

    return `${day}.${month}.${year}`;
}

export function formatContestSpecialPeriodLabel(from: string, to: string): string {
    return `с ${formatYmdToDisplay(from)} по ${formatYmdToDisplay(to)}`;
}
